import MainModal from '@/common/components/base/modal/Modal.tsx';
import { MainModalProps } from '@/common/components/base/modal/Modal.type.ts';
import LogoutIcon from '@/common/assets/icons/logoutIcon.svg?react';
import { Box, Center, Flex } from 'styled-system/jsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import Button from '@/common/components/base/button/Button.tsx';
import useAuth from '@/common/hooks/useAuth.ts';

export default ({ open, closeModal }: MainModalProps) => (
  <MainModal open={open} closeModal={closeModal}>
    <LogoutModal closeModal={closeModal} open={open} />
  </MainModal>
);

const LogoutModal = ({ closeModal }: MainModalProps) => {
  const { logOut } = useAuth();
  return (
    <>
      <Box mb={'40px'} maxW="300px" mx="auto">
        <Center mb={'20px'}>
          <LogoutIcon />
        </Center>
        <Typography textAlign="center" mb={'20px'}>
          آیا برای خروج از حساب کاربری مطمئن هستید؟
        </Typography>
        <Typography mx="20px" textStyle="b2" color="black-3">
          در صورت خروج، برای ورود مجدد بایستی از طریق وارد کردن شماره تماس اقدام
          نمایید.
        </Typography>
      </Box>
      <Flex mb="15px" gap="10px">
        <Button
          onClick={closeModal}
          fullWidth
          variant={'outlined'}
          color="common"
        >
          انصراف
        </Button>
        <Button onClick={logOut} fullWidth color="danger">
          خروج
        </Button>
      </Flex>
    </>
  );
};
